import React from "react";

export const Loading = ({
  size = "md",
  text = "Loading...",
  fullScreen = false,
}) => {
  const sizeClasses = {
    sm: "h-6 w-6 border-2",
    md: "h-12 w-12 border-2",
    lg: "h-16 w-16 border-4",
  };

  const LoadingSpinner = () => (
    <div
      className="flex flex-col items-center justify-center"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div
        className={`animate-spin rounded-full border-custom-blue border-t-transparent ${sizeClasses[size]}`}
        aria-hidden="true"
      />
      {text && <p className="mt-4 text-gray-700">{text}</p>}
      <span className="sr-only">{text || "Loading"}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner />
      </div>
    );
  }

  return <LoadingSpinner />;
};

export const LoadingOverlay = ({ text = "Loading..." }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      role="alertdialog"
      aria-busy="true"
      aria-label={text}
    >
      <div className="bg-white rounded-lg p-8 shadow-xl">
        <Loading text={text} size="lg" />
      </div>
    </div>
  );
};

export const InlineLoading = ({ text }) => {
  return (
    <div className="flex items-center space-x-2" role="status" aria-live="polite">
      <div
        className="animate-spin rounded-full h-4 w-4 border-2 border-custom-blue border-t-transparent"
        aria-hidden="true"
      />
      {text && <span className="text-sm text-gray-700">{text}</span>}
      {!text && <span className="sr-only">Loading</span>}
    </div>
  );
};

export const SkeletonLoader = ({ count = 1, className = "" }) => {
  return (
    <div
      className={`space-y-3 ${className}`}
      aria-hidden="true"
      role="presentation"
    >
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className="animate-pulse bg-gray-200 rounded h-4 w-full"
        />
      ))}
    </div>
  );
};

export default Loading;
